import { TooltipView } from 'src/ConsentManagement/TooltipView';
import { useEffect } from 'preact/hooks';
import { useLanguage } from 'src/Shared/EventPublisher/UseLanguage';
import { log } from 'src/ConsentManagement/Logging/ErrorLogger';
import { render } from 'preact';
import { getText } from '../../TranslationService';
import { Heading } from '../shared/Heading';
import { Description } from '../shared/Description';
import { Accordion } from '../shared/Accordion';
import { AccordionHeader } from '../shared/Accordion/AccordionHeader';
import { AccordionContent } from '../shared/Accordion/AccordionContent';
import { VendorsLink } from '../shared/VendorsLink';
import { ScrollableContent } from '../shared/ScrollableContent';

const VENDORS_LINK_CONTAINER = 'vendors_link_container';

const parser = new DOMParser();

export const Content = () => {
  const stacksIds = [1, 2, 3];
  const [language] = useLanguage();

  const Stack = (props: any) => {
    const { stackNumber } = props;
    const id = `cc-ec-stk-${stackNumber}`;
    return (
      <Accordion uid={id}>
        <AccordionHeader uid={id} title={getText(`ec_stack${stackNumber}_title`)}></AccordionHeader>
        <AccordionContent>{getText(`ec_stack${stackNumber}_details`)}</AccordionContent>
      </Accordion>
    );
  };

  useEffect(() => {
    try {
      render(<VendorsLink translationPrefix="explicit" />, document.getElementById(VENDORS_LINK_CONTAINER));
    } catch (e) {
      log('cannot set vendors link', e);
    }
  }, [language]);

  const htmlTemplate = getText(`message`).replace(`{VENDORS_LINK}`, `<span id="${VENDORS_LINK_CONTAINER}"></span>`);

  const messageDocument = parser.parseFromString(htmlTemplate, 'text/html');

  new TooltipView().enhanceView(messageDocument);

  return (
    <ScrollableContent>
      <Heading>
        <div id="GDPRLanguageSwitcherContainer" class="ccm-col switcher"></div>
      </Heading>
      <Description innerContent={messageDocument} />
      <div class="mt2">
        {stacksIds.map((stackId) => (
          <Stack stackNumber={stackId} />
        ))}
      </div>
    </ScrollableContent>
  );
};
